import React from "react";

const Money = () => {
  return (
    <svg
      width="12"
      height="11"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 18.7334C14.9658 18.7334 19.0791 14.6289 19.0791 9.6543C19.0791 4.68848 14.9658 0.575195 9.99121 0.575195C5.02539 0.575195 0.920898 4.68848 0.920898 9.6543C0.920898 14.6289 5.03418 18.7334 10 18.7334ZM10 14.7871C9.75391 14.7871 9.57812 14.6201 9.57812 14.3652V13.7412C8.28613 13.6357 7.31055 12.9502 7.04688 11.9746C7.01172 11.8691 6.99414 11.7637 6.99414 11.6582C6.99414 11.2979 7.24023 11.043 7.61816 11.043C7.92578 11.043 8.14551 11.2012 8.26855 11.5352C8.40918 12.0713 8.83984 12.4756 9.57812 12.5723V10.1641L9.4375 10.1289C7.91699 9.76855 7.11719 9.07422 7.11719 7.89648C7.11719 6.61328 8.14551 5.73438 9.57812 5.59375V4.9873C9.57812 4.73242 9.75391 4.55664 10 4.55664C10.2373 4.55664 10.4219 4.73242 10.4219 4.9873V5.59375C11.6436 5.72559 12.5576 6.40234 12.8037 7.35156C12.8301 7.44824 12.8564 7.55371 12.8564 7.65918C12.8564 8.01074 12.6016 8.25684 12.2324 8.25684C11.916 8.25684 11.7139 8.07227 11.582 7.77344C11.4062 7.2373 11.002 6.88574 10.4219 6.78906V9.06543L10.6152 9.10938C12.1973 9.39941 13.0059 10.1377 13.0059 11.3857C13.0059 12.7744 11.8984 13.6182 10.4219 13.75V14.3652C10.4219 14.6201 10.2373 14.7871 10 14.7871ZM9.57812 8.85449V6.78027C8.875 6.88574 8.45312 7.30762 8.45312 7.80859C8.45312 8.30078 8.78711 8.62598 9.5166 8.83691L9.57812 8.85449ZM10.4219 10.3662V12.5723C11.2568 12.4844 11.6787 12.0537 11.6787 11.4736C11.6787 10.9639 11.3887 10.6211 10.5889 10.4102L10.4219 10.3662Z"
        fill="#1C1C1E"
      />
    </svg>
  );
};

export default Money;
